import { BANNER } from '@studio/constants/Sources';
/**
 * Gets the updated banner visibility states from the corresponding program layers.
 *
 * When the program changes, this function updates each banner's `hidden` property
 * to match the visibility state defined in the program's layers.
 *
 * @param {Object} program - The program object containing layer configurations
 * @param {Array<Object>} program.layers - Array of layer objects in the program
 * @param {Array<Object>} banners - Array of banner objects to synchronize
 * @returns {Array<Object>} Updated banners array with synchronized visibility states
 */
const getUpdatedBannerVisibility = (program, banners) => {
  const { layers } = program;

  const bannerVisibilityMap = new Map();
  for (const layer of layers) {
    if (layer.source.type === BANNER) {
      bannerVisibilityMap.set(layer._id, layer.source.hidden);
    }
  }

  return banners.map(banner => {
    const isInProgram = bannerVisibilityMap.has(banner._id);
    if (isInProgram) {
      return {
        ...banner,
        source: {
          ...banner.source,
          hidden: bannerVisibilityMap.get(banner._id)
        }
      };
    }

    // If the banner is not in the program, set it to its default value (hidden: true)
    return {
      ...banner,
      source: {
        ...banner.source,
        hidden: true
      }
    };
  });
};

export default getUpdatedBannerVisibility;
